// extracted by mini-css-extract-plugin
export default {"section":"styles_section__MBhNW","img":"styles_img__Iq75K","heading":"styles_heading__hRXP+","para":"styles_para__Hdw7n"};